export const yodaNotificationsConstants = {
  UPSERT_NOTIFICATION_REQUEST: "YODANOTIFICATIONS_UPSERT_REQUEST",
  UPSERT_NOTIFICATION_SUCCESS: "YODANOTIFICATIONS_UPSERT_SUCCESS",
  UPSERT_NOTIFICATION_FAILURE: "YODANOTIFICATIONS_UPSERT_FAILURE",
};
